var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7245 12.4918C20.7245 12.7528 20.6238 12.9735 20.4532 13.1445L12.6785 21.1099C12.4878 21.3006 12.2568 21.4013 12.0056 21.4013C11.7442 21.4013 11.4931 21.2908 11.3328 21.1001L3.54734 13.1445C3.46054 13.0595 3.3918 12.9578 3.34526 12.8456C3.29872 12.7333 3.27532 12.6128 3.27649 12.4913C3.27649 11.9693 3.67806 11.5776 4.20049 11.5776C4.44134 11.5776 4.68263 11.6779 4.8532 11.8391L12.0052 19.1513L19.1568 11.8386C19.3278 11.6779 19.5588 11.5772 19.8099 11.5772C20.3319 11.5772 20.7241 11.9693 20.7241 12.4913M20.7241 3.52135C20.7241 3.77249 20.6233 4.00349 20.4528 4.17406L12.6781 12.1296C12.4873 12.3203 12.2563 12.4211 12.0052 12.4211C11.7438 12.4211 11.4926 12.3203 11.3323 12.1296L3.54734 4.17449C3.37677 3.99363 3.27649 3.77292 3.27649 3.52177C3.27452 3.39989 3.29707 3.27885 3.34281 3.16586C3.38855 3.05286 3.45654 2.95022 3.54273 2.86402C3.62893 2.77782 3.73158 2.70984 3.84457 2.6641C3.95756 2.61836 4.0786 2.59581 4.20049 2.59777C4.44134 2.59777 4.68263 2.70792 4.8532 2.86863L12.0052 10.1715L19.1568 2.86863C19.3278 2.70792 19.5588 2.59777 19.8099 2.59777C20.3319 2.59777 20.7241 2.99892 20.7241 3.52135Z",
    fill: "#CE202F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.d78e3cdd13e6d305d899bb3cc9afa2e3.svg";
export { ForwardRef as ReactComponent };